import React, { useState, useEffect } from 'react';
import '../StyleSheets/Loader.css';
import loaderIcon from '../Graphics/Icons/loaderIcon.svg';
import gsap, { Linear } from 'gsap';


export default function Loader(props) {

    const iconRef = React.createRef();

    const [hasMounted, setMounted] = useState( false );

    useEffect( () => {
        if( !hasMounted ) {

            setMounted( true );
            // console.log( iconRef.current );
            gsap.to( iconRef.current, 1.5, {rotation: 360, ease:Linear.easeNone, repeat: -1 } );

        }
    }, [hasMounted, iconRef] );

    return (
        <div id="loaderContainer">
            <div id="loadingText">מעדכן נתונים</div>
            <img id="loaderIcon" src={loaderIcon} ref={iconRef} alt="loaderIcon"/>
        </div>
    )
}